import { windowRef } from "./window";
import {
  readLocalStorage,
  readSessionStorage,
  writeLocalStorage,
  writeSessionStorage
} from "./safeStorage";

type StorageData = { [key: string]: any };

const parseStorage = (value: string | null): StorageData => {
  if (!value || value === 'undefined') return {};
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (error) {
    return {};
  }
};

export const setValueInLocalStorage = (key: any, value: any) => {
  const storage = parseStorage(readLocalStorage('salon'));
  storage[key] = value;
  writeLocalStorage('salon', JSON.stringify(storage));
}

export const getValueFromLocalStorage = (key: any) =>
  parseStorage(readLocalStorage('salon'))[key] ?? null;

export const removeItemFromLocalStorage = (key: any) => {
  const storage = parseStorage(readLocalStorage('salon'));
  delete storage[key];
  writeLocalStorage('salon', JSON.stringify(storage));
}

export const setValueInSessionStorage = (key: any, value: any) => {
  const storage = parseStorage(readSessionStorage('salon'));
  storage[key] = value;
  writeSessionStorage('salon', JSON.stringify(storage));
}

export const getValueFromSessionStorage = (key: any) =>
  parseStorage(readSessionStorage('salon'))[key] ?? null;

export const removeItemFromSessionStorage = (key: any) => {
  const storage = parseStorage(readSessionStorage('salon'));
  delete storage[key];
  writeSessionStorage('salon', JSON.stringify(storage));
}

export const setValueInCookies = (key: any, value: any, expDays: any) => {
  const browserWindow = windowRef();
  if (browserWindow) browserWindow.document.cookie = key + "=" + value + ';expires=' + expDays + ';path=/';
}

export const getValueFromCookies = (key: any) => {
  const browserWindow = windowRef();
  if (browserWindow) {
    let value = null;
    var name = key + "=";
    var decodedCookie = decodeURIComponent(browserWindow.document.cookie);
    var ca = decodedCookie.split(';');
    ca && ca.map((dataString) => {
      //remove spaces from string at starting
      while (dataString.charAt(0) == ' ') {
        dataString = dataString.substring(1);
      }
      if (dataString.indexOf(name) == 0) {
        value = dataString.substring(name.length, dataString.length);
      }
    })
    return value;
  }
}

export const removeValueFromCookies = (key: any) => {
  const browserWindow = windowRef();
  if (browserWindow) browserWindow.document.cookie = key + '=;expires=' + new Date().toUTCString() + ';path=/';
}

